import _ from 'lodash';
import React, { useMemo } from 'react';
import { Tag } from '@duxton-web/ui';

import { INTERNAL_STATUS } from 'omega-rtc/constants/ucd';

const tagColorMap = {
  [INTERNAL_STATUS.draft]: 'grey',
  [INTERNAL_STATUS.active]: 'green',
  [INTERNAL_STATUS.deactivated]: 'red',
};

const ProjectStatusTag = ({ status }) => {
  const tagColor = useMemo(
    () => tagColorMap[status],
    [status],
  );
  return (<Tag color={tagColor}>
    {_.capitalize(status)}
  </Tag>);
};

export default ProjectStatusTag;
